var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 flex-col"},[_c('h2',{staticClass:"font-semibold text-peach mb-4"},[_vm._v("Scanner Profil anlegen")]),_c('ScanerUserForm',{on:{"onButtonClick":function () { return _vm.$emit('onButtonClick'); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }